<template>
    <Dialog :open="open" @update:open="handleClose">
        <DialogContent>
            <DialogHeader>
                <DialogTitle>
                    Detach {{ storage }} bucket
                </DialogTitle>
            </DialogHeader>

            <div class="space-y-4">
                <div class="text-xs text-muted-foreground">
                    <div>
                        Are you sure you want to detach your custom
                        <span class="font-medium text-primary">
                            {{ storage }} bucket?
                        </span>
                    </div>
                    <div class="mt-[21px]">
                        After detaching {{ storage }} bucket, all of your Plugin
                        users won't be able to access files on your storage. You
                        can reconnect your storage bucket again later.
                    </div>
                </div>
                <div class="mt-4 flex items-center gap-2">
                    <input
                        id="confirm-detach"
                        v-model="checked"
                        type="checkbox"
                        class="h-4 w-4 rounded border-new-gray-200 text-new-blue-600 focus:ring-2 focus:ring-new-blue-500"
                    />
                    <label
                        for="confirm-detach"
                        class="text-xs font-medium text-primary"
                    >
                        Confirm that you want to detach {{ storage }} bucket
                    </label>
                </div>
            </div>

            <DialogFooter class="flex justify-between">
                <Button size="lg" variant="ghost" @click="handleClose">
                    Cancel
                </Button>
                <Button
size="lg"
                    :disabled="!checked"
                    variant="destructive"
                    data-cy="plugin-settings-update-domains-confirm"
                    @click="deleteStorage"
                >
                    Detach now
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { PropType, ref, computed } from 'vue';
import IToken from '@/types/Plugin/IToken';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const props = defineProps({
    open: {
        type: Boolean,
        required: true,
    },
    token: {
        type: Object as PropType<IToken>,
        required: true,
    },
    provider: {
        type: String as PropType<'aws' | 'gcs' | 'cloudflare' | 'digitalocean'>,
        required: true,
    },
});

const emit = defineEmits(['close', 'deleteStorage', 'update:open']);

const checked = ref(false);

const storage = computed(() => {
    const map: Record<string, string> = {
        aws: 'Amazon S3',
        gcs: 'Google Cloud',
        cloudflare: 'Cloudflare R2',
        digitalocean: 'DigitalOcean Spaces',
    };

    return map[props.provider] ?? null;
});

const handleClose = () => {
    emit('close');
    emit('update:open', false);
};

const deleteStorage = () => {
    emit('deleteStorage', props.token.id);
};
</script>
